export default {
  'CancelSubscription': () => import(/* webpackChunkName: "account" */ './CancelSubscription'),
  'ChangePassword': () => import(/* webpackChunkName: "account" */ './ChangePassword'),
  'ChangeEmail': () => import(/* webpackChunkName: "account" */ './ChangeEmail'),
  'credentials-data': () => import(/* webpackChunkName: "account" */ './CredentialsData'),
  'payment-data': () => import(/* webpackChunkName: "account" */ './PaymentData')
}
